<template>
  <v-app>
    <v-content>
      <v-container :style="{ 'min-height': winHeight + 'px' }" class="ma-0 pa-0 first-container" fluid>
        <v-parallax :key="getKey('slide1')" :src="getImg('firstSlideImage')" :height="winHeight" :jumbotron="mobile"
                    alt="First slide image background">
          <v-layout column align-center justify-center text-xs-center>
            <v-flex class="main-container">
              <h1 class="white--text main-title--first shadow" :style="{'font-size': titleSize}">
                Hi! I'm Tarás.</h1>
            </v-flex>
          </v-layout>
          <div class="submain-container text-xs-center">
            <a @click="scrollToElement('.about-container')">
              <p class="learn-more shadow">Learn more about me</p>
              <span class="arrow-button">
                <font-awesome-icon :icon="['fas', 'chevron-down']" size="2x"/>
              </span>

            </a>
          </div>
        </v-parallax>
      </v-container>

      <v-container :style="{ 'min-height': winHeight + 'px' }" class="about-container hidden">
        <v-layout row align-left justify-center text-xs-left class="grey--after text--darken-4"
                  v-bind="aboutContainerType">
          <v-flex xs12 sm3 md2
                  :class="{'mt-3': $vuetify.breakpoint.smAndUp, 'ma-1': $vuetify.breakpoint.xs, 'text-xs-center': true, 'justify-center': true, 'mr-3': true}">
            <v-avatar :size=" '140px' " class="grey lighten-4 ">
              <img :src="getImg( 'avatar') " alt="avatar " class="avatar">
            </v-avatar>
          </v-flex>
          <v-flex xs12 sm9 md10 :class="{'ma-1': $vuetify.breakpoint.xs}">
            <h2 class="section-title grey--text text--darken-4 mt-3 ">About:</h2>
            <p class="subheading text-xs-justify">
              My name is Tarás. <br/>
              I'm Web Developer with {{ yearsOfExperience }}+ years of experience.
            </p>

            <p class="subheading text-xs-justify">
              I'm mostly focused on Frontend development with HTML, CSS, Javascript, React, Typescript and other modern technologies and frameworks.
              Also I have some experience in Backend and Full-stack(LEMP) development of websites and services.
            </p>

            <p class="subheading text-xs-justify">
              You can see my work history on
              <a target="_blank" href="https://www.linkedin.com/in/taras-semenyuk-05b48965/ "
                 rel="noopener">LinkedIn</a>.
            </p>
          </v-flex>
        </v-layout>
        <v-layout class="technologies">
          <v-flex xs12 sm12 md12 :class="{'ma-1': $vuetify.breakpoint.xs}">
            <h2 class="section-title grey--text text--darken-4 ">Skills:</h2>
            <tech-view v-bind:items="technologies.actual">Technologies that I'm currently working with:</tech-view>
            <tech-view v-bind:items="technologies.other">Other technologies that I have experience with or worked
              before:
            </tech-view>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <h2 class="section-title grey--text text--darken-4 ">Outside of work:</h2>
            <p class="subheading">
              Outside of work I like motorcycles, sports and traveling. You can find on
              <!--suppress HtmlUnknownTarget -->
              <a href="/blog" target="_blank">this map</a> interesting places to visit based on my experience.
            </p>

            <p class="subheading">
              There is also a map of countries which I've visited:

              <div :is="mapFrameName"></div>

              <ul v-if="countriesList.length" class="countries-list text-xs-center">
                <li v-for="item in countriesList" class="countries-list--flag" :key="item" :title="getCountryName(item)">
                  {{ item }}
                </li>
              </ul>
            </p>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="ma-0 pa-0 form-container hidden" fluid>
        <v-parallax :key="getKey('slide3')" :src="getImg('formSlideImage') " :height="winHeight " :jumbotron="mobile "
                    alt="Third slide image background">
          <v-layout align-center justify-center>
            <a id="contact"/>
            <ask-form/>
          </v-layout>
          <footer-bar/>
        </v-parallax>
      </v-container>
    </v-content>
    <CookiesBar :is-cookies-bar-enabled="isCookiesBarEnabled" :on-accept-cookies="onAcceptCookies"/>
  </v-app>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import axios from 'axios';
import { flag, name } from 'country-emoji';
import Cookies from 'js-cookie';
import smoothscroll from 'smoothscroll-polyfill';
import Vue from 'vue';

import AskForm from './components/AskForm';
import CookiesBar from './components/CookiesBar';
import FooterBar from './components/FooterBar';
import TechView from './components/TechView';
import config from './config';
import { COOKIES_ACCEPT_NAME, getApiUrl } from './utils';

// scroll fix for old browsers
smoothscroll.polyfill();

export default {
  data() {
    return {
      technologies: {
        actual: [],
        other: [],
      },
      mapFrame: null,
      countriesList: [],
      isCookiesBarEnabled: false,
    };
  },
  created() {
    this.config = config;

    Vue.component('mapFrame', {
      template: '<iframe src="/static/map.html" style="width: 100%; min-height: 400px; border: 0;" title="Map of countries which I\'ve visited"></iframe>',
    });

    this.mapFrameName = 'mapFrame';
    /*     this.mapFrame =
      '<iframe src="/static/map.html" style="width: 100%; min-height: 400px;" frameBorder="0" title="Map of countries which I\'ve visited"></iframe>'; */

    this.getCountriesFlags();
    this.getTechnologies();
  },
  components: {
    CookiesBar,
    'tech-view': TechView,
    'ask-form': AskForm,
    FooterBar,
    FontAwesomeIcon,
  },
  computed: {
    aboutContainerType() {
      const binding = {};
      if (this.$vuetify.breakpoint.name === 'xs') binding.column = true;
      return binding;
    },
    titleSize() {
      if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm') {
        return '2em';
      }
      return '4vw';
    },
    yearsOfExperience() {
      const startYear = 2008;
      const currentYear = new Date().getFullYear();
      return currentYear - startYear - 1;
    },
  },
  methods: {
    /* eslint-disable */
    getKey(id) {
      return `${id}${this.$vuetify.breakpoint.name}`;
    },
    getImg(key) {
      const imgConfig = this.config.images[key];
      if (!imgConfig) {
        return null;
      }

      const breakpoint = this.$vuetify.breakpoint.name;
      const imgPath = imgConfig[breakpoint] || imgConfig['default'];

      if (imgPath) {
        return require(`@/assets/${imgPath}`);
      }

      return null;
    },
    /* eslint-enable */
    scrollToElement(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    },
    async getCountriesFlags() {
      try {
        const response = await axios.get(`${getApiUrl()}/countries`);
        this.countriesList = response.data.map(code => flag(code));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    async getTechnologies() {
      try {
        const response = await axios.get(`${getApiUrl()}/technologies`);
        this.technologies = response.data;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    },
    getCountryName(code) {
      return name(code);
    },
    onAcceptCookies() {
      Cookies.set(COOKIES_ACCEPT_NAME, 'true');
      this.isCookiesBarEnabled = !this.isCookiesBarEnabled;
    },
  },
  props: {
    winHeight: Number,
    mobile: {
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      // show non-first slides ONLY after first render
      const elements = document.querySelectorAll('.about-container, .form-container');
      Array.prototype.forEach.call(elements, item => {
        item.classList.remove('hidden');
      });

      // check cookies
      if (!Cookies.get(COOKIES_ACCEPT_NAME)) {
        setTimeout(() => {
          this.isCookiesBarEnabled = true;
        }, 1000);
      }
    });
  },
};
</script>

<style scoped>
.first-container {
  background-color: #2d2727;
  min-height: 100%;
}

.hidden {
  display: none;
}

.about-container a {
  color: rgba(0, 0, 0, 0.87) !important;
  text-decoration: none;
  border-bottom: 1px rgba(0, 0, 0, 0.87) dotted;
}

.about-container a:hover {
  color: #00669c !important;
  transition: all 0.4s ease;
}

.main-container {
  flex: 0 1 auto !important;
}

.submain-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
}

.submain-container a {
  opacity: 0.6;
}

.submain-container a:hover {
  opacity: 1;
  transition: all 0.4s ease;
}

.arrow-button {
  animation: bounce-in 3s infinite;
}

.arrow-button:hover {
  animation: none;
}

.submain-container a:hover .arrow-button {
  animation: none;
}

@keyframes bounce-in {
  0% {
    opacity: 0.3;
    transition: opacity 0.5s;
  }
  50% {
    opacity: 1;
    transition: opacity 0.5s;
  }
  100% {
    opacity: 0.3;
    transition: opacity 0.5s;
  }
}

.learn-more {
  font-weight: 300;
  font-size: 16px;
}

.main-title--first {
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 2;
}

.section-title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: -0.04em;
}

.shadow {
  text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.3);
}

.avatar {
  border: 1px solid #eee;
}

.countries-list {
  padding-left: 0;
}

.countries-list--flag {
  list-style-type: none;
  display: inline-block;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue